module.exports = __webpack_public_path__ + "img/01@2x.e6733a7f.png";